// @flow
import React, { useEffect, useMemo, useState } from "react";
import getTimeIntervalsForIncrement from "@justpark/helpers/src/getTimeIntervalsForIncrement/getTimeIntervalsForIncrement";
import bem from "@justpark/helpers/src/bem/bem";
import SingleDatePickerDropDown from "../SingleDatePickerDropDown";
import NativeFancyDropdown from "../NativeFancyDropdown";
import Typography from "../Typography";

import "./dateTimeDropDown.scss";

type Props = {
  date: string,
  time: string,
  onDateChange: (string) => void,
  onTimeChange: (string) => void,
  datePlaceholder?: string,
  timePlaceholder?: string,
  label?: string,
  timeInterval?: number
};

const baseClass = "c-date-time-drop-down";

const DateTimeDropDown = ({
  date,
  time,
  onDateChange,
  onTimeChange,
  datePlaceholder = "",
  timePlaceholder = "",
  label,
  timeInterval = 30
}: Props) => {
  // Ensure that initially display values is shown in the interval list
  // And that the value stays there even when changed
  const [initialTime, setInitialTime] = useState(time);

  useEffect(() => {
    if (initialTime === "") {
      setInitialTime(time);
    }
  }, [initialTime, setInitialTime, time]);

  const defaultOptions = useMemo(
    () =>
      getTimeIntervalsForIncrement(timeInterval, initialTime).map((value) => ({
        label: value,
        value
      })),
    [initialTime, timeInterval]
  );

  return (
    <div className={baseClass}>
      {label && (
        <label className={bem(baseClass, "label")}>
          <Typography size="secondary" bold color="primary">
            <div className={bem(baseClass, "labeltext")}>{label}</div>
          </Typography>
        </label>
      )}
      <div className={bem(baseClass, "input-container")}>
        <SingleDatePickerDropDown
          onChange={onDateChange}
          error=""
          hideErrorCross
          date={date}
          placeholder={datePlaceholder}
        />

        <NativeFancyDropdown
          options={defaultOptions}
          selected={time}
          onChange={onTimeChange}
          placeholder={timePlaceholder}
        />
      </div>
    </div>
  );
};

export default DateTimeDropDown;
